/**
 * Karmaveda Theme - Main JavaScript
 * ==================================
 */

(function() {
  'use strict';

  function fetchWithRetry(url, options, retries) {
    retries = retries === undefined ? 3 : retries;

    return fetch(url, options).then(function(response) {
      if (response.status === 429 && retries > 0) {
        var retryAfter = parseInt(response.headers.get('Retry-After') || '1', 10);
        var jitter = Math.random() * 500;
        var delay = retryAfter * 1000 + jitter;
        return new Promise(function(resolve) {
          setTimeout(function() {
            resolve(fetchWithRetry(url, options, retries - 1));
          }, delay);
        });
      }
      return response;
    });
  }

  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    initMobileMenu();
    initCartDrawer();
    initSearch();
    initAddToCart();
    initCartQuantity();
    initCartBuyNow();
    checkCartDrawerFlag();
  });

  /**
   * Check if cart drawer should open (after redirect from /cart page)
   */
  function checkCartDrawerFlag() {
    if (sessionStorage.getItem('openCartDrawer') === 'true') {
      sessionStorage.removeItem('openCartDrawer');
      setTimeout(function() {
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer(true);
        }
      }, 100);
    }
  }

  /**
   * Mobile Menu
   */
  function initMobileMenu() {
    return;
  }

  /**
   * Cart Drawer - Now uses custom elements from cart-drawer.js
   */
  function initCartDrawer() {
    const cartToggle = document.querySelector('[data-cart-toggle]');

    // Open cart on toggle click
    if (cartToggle) {
      cartToggle.addEventListener('click', function(e) {
        e.preventDefault();
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer(true);
        }
      });
    }

    // Note: Close handlers are now managed by the cart-drawer custom element
  }

  /**
   * Cart Buy Now Button - Direct Razorpay Checkout
   */
  function initCartBuyNow() {
    document.addEventListener('click', function(e) {
      const buyNowBtn = e.target.closest('[data-cart-buy-now]');
      if (!buyNowBtn) return;

      e.preventDefault();

      // Get variant ID and quantity
      const variantId = buyNowBtn.dataset.variantId;
      const quantity = 1;

      // If this is from product page, we need to add to cart first
      if (variantId) {
        buyNowBtn.disabled = true;
        buyNowBtn.textContent = 'Processing...';

        // Add product to cart first
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        })
        .then(response => {
          if (!response.ok) throw new Error('Failed to add to cart');
          return response.json();
        })
        .then(item => {
          // Product added, now proceed to checkout
          proceedToCheckout(buyNowBtn);
        })
        .catch(error => {
          console.error('Add to cart error:', error);
          buyNowBtn.disabled = false;
          buyNowBtn.textContent = 'Buy Now';
          alert('Unable to add product to cart. Please try again.');
        });
      } else {
        // This is from cart drawer, proceed directly
        proceedToCheckout(buyNowBtn);
      }
    });

    function proceedToCheckout(buyNowBtn) {
      // Check if Razorpay Magic Checkout is available
      if (typeof window.RazorpayMagicCheckout !== 'undefined' && window.RazorpayMagicCheckout.open) {
        // Use Razorpay Magic Checkout if available
        window.RazorpayMagicCheckout.open();
        if (buyNowBtn) {
          buyNowBtn.disabled = false;
          buyNowBtn.textContent = 'Buy Now';
        }
      } else {
        // Redirect to checkout - Razorpay app will intercept
        window.location.href = '/checkout';
      }
    }
  }

  /**
   * Note: Cart rendering is now handled by cart-drawer.js custom elements
   * These functions are kept for backward compatibility with add-to-cart
   */

  /**
   * Search Bar
   */
  function initSearch() {
    const searchBar = document.querySelector('[data-search-bar]');
    const searchToggle = document.querySelector('[data-search-toggle]');
    const searchClose = document.querySelector('[data-search-close]');

    if (!searchBar || !searchToggle) return;

    searchToggle.addEventListener('click', function() {
      searchBar.classList.add('is-open');
      searchBar.setAttribute('aria-hidden', 'false');
      const input = searchBar.querySelector('input');
      if (input) input.focus();
    });

    if (searchClose) {
      searchClose.addEventListener('click', function() {
        searchBar.classList.remove('is-open');
        searchBar.setAttribute('aria-hidden', 'true');
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchBar.classList.contains('is-open')) {
        searchBar.classList.remove('is-open');
        searchBar.setAttribute('aria-hidden', 'true');
      }
    });
  }

  /**
   * Add to Cart
   */
  function initAddToCart() {
    document.addEventListener('click', function(e) {
      const addButton = e.target.closest('[data-add-to-cart]');
      if (!addButton) return;

      e.preventDefault();

      const form = addButton.closest('form');
      if (form) {
        const formData = new FormData(form);
        const data = {};
        formData.forEach((value, key) => {
          data[key] = value;
        });
        addToCart(data.id, data.quantity || 1, addButton);
      } else {
        const variantId = addButton.dataset.variantId;
        if (variantId) addToCart(variantId, 1, addButton);
      }
    });
  }

  /**
   * Show Toast Notification
   */
  function showToast(message, type = 'error') {
    // Remove existing toast if any
    const existingToast = document.querySelector('.toast-notification');
    if (existingToast) {
      existingToast.remove();
    }

    // Create toast element
    const toast = document.createElement('div');
    toast.className = `toast-notification toast-notification--${type}`;
    toast.textContent = message;
    document.body.appendChild(toast);

    // Trigger animation
    setTimeout(() => toast.classList.add('toast-notification--visible'), 10);

    // Auto hide after 4 seconds
    setTimeout(() => {
      toast.classList.remove('toast-notification--visible');
      setTimeout(() => toast.remove(), 300);
    }, 4000);
  }

  /**
   * Add Item to Cart
   */
  function addToCart(variantId, quantity, button) {
    const originalHTML = button.innerHTML;
    button.innerHTML = 'Adding...';
    button.disabled = true;

    fetchWithRetry(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: parseInt(quantity)
      })
    })
    .then(response => {
      // Handle various error status codes
      if (response.status === 422 || response.status === 400) {
        return response.json().then(data => {
          const errorMessage = data.description || data.message || data.errors || 'Unable to add to cart';
          showToast(errorMessage, 'error');

          // Reset button
          button.innerHTML = originalHTML;
          button.disabled = false;

          // Don't open cart drawer on error
          throw new Error(errorMessage);
        });
      }

      if (!response.ok) {
        return response.text().then(text => {
          let errorMessage = 'Failed to add to cart';
          try {
            const data = JSON.parse(text);
            errorMessage = data.description || data.message || data.errors || errorMessage;
          } catch (e) {
            // text is not JSON
          }
          showToast(errorMessage, 'error');
          throw new Error(errorMessage);
        });
      }

      return response.json();
    })
    .then(item => {
      // Success - check if quantity was adjusted
      const requestedQty = parseInt(quantity);
      const addedQty = item.quantity || requestedQty;

      button.innerHTML = '✓ Added!';

      // Open cart drawer with force update to show new item
      if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer(true);
      }

      // If quantity was adjusted (less than requested), show warning
      if (addedQty < requestedQty) {
        showToast(`Only ${addedQty} item(s) were added to your cart due to availability.`, 'warning');
      }

      setTimeout(function() {
        button.innerHTML = originalHTML;
        button.disabled = false;
      }, 1500);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      button.innerHTML = originalHTML;
      button.disabled = false;
    });
  }

  /**
   * Update Cart Count
   */
  window.updateCartCount = function updateCartCount(count) {
    count = parseInt(count) || 0;
    const cartToggle = document.querySelector('[data-cart-toggle]');
    let bubble = document.querySelector('[data-cart-count]');

    if (count > 0) {
      if (!bubble && cartToggle) {
        bubble = document.createElement('span');
        bubble.className = 'header__cart-count';
        bubble.setAttribute('data-cart-count', '');
        cartToggle.appendChild(bubble);
      }
      if (bubble) bubble.textContent = count < 100 ? count : '99+';
    } else {
      if (bubble) bubble.remove();
    }

    const drawerCount = document.getElementById('cart-drawer-count');
    if (drawerCount) drawerCount.textContent = count;
  };

  /**
   * Cart Quantity Buttons (on cart page)
   */
  function initCartQuantity() {
    document.addEventListener('click', function(e) {
      const minusBtn = e.target.closest('[data-cart-quantity-minus]');
      const plusBtn = e.target.closest('[data-cart-quantity-plus]');

      if (minusBtn) {
        const key = minusBtn.dataset.cartQuantityMinus;
        const input = document.querySelector(`[data-cart-quantity-input="${key}"]`);
        if (input && parseInt(input.value) > 1) {
          input.value = parseInt(input.value) - 1;
          updateCartItemQuantity(key, parseInt(input.value));
        }
      }

      if (plusBtn) {
        const key = plusBtn.dataset.cartQuantityPlus;
        const input = document.querySelector(`[data-cart-quantity-input="${key}"]`);
        if (input) {
          input.value = parseInt(input.value) + 1;
          updateCartItemQuantity(key, parseInt(input.value));
        }
      }
    });
  }

  /**
   * Update Cart Item Quantity - Now delegated to cart-drawer-items custom element
   * This function is kept for backward compatibility
   */
  function updateCartItemQuantity(key, quantity) {
    const cartItems = document.querySelector('cart-drawer-items');
    if (cartItems && typeof cartItems.updateQuantity === 'function') {
      cartItems.updateQuantity(key, quantity);
    }
  }

  /**
   * Format Money
   */
  function formatMoney(cents) {
    const amount = Math.round(cents / 100).toLocaleString('en-IN');
    return '₹' + amount;
  }

  window.formatMoney = formatMoney;
  window.showToast = showToast;

})();
